export const breakpoints = {
  tablet: 767,
  laptop: 1024,
  desktop: 1280,
};
